import apiV2 from '@/api/v2';
export var ObjectTypeStatus;
(function (ObjectTypeStatus) {
    ObjectTypeStatus["ACTIVE"] = "active";
    ObjectTypeStatus["ARCHIVED"] = "archived";
})(ObjectTypeStatus || (ObjectTypeStatus = {}));
export var ObjectStatus;
(function (ObjectStatus) {
    ObjectStatus["ACTIVE"] = "active";
    ObjectStatus["ARCHIVED"] = "archived";
})(ObjectStatus || (ObjectStatus = {}));
export const getObjectsList = async (params) => {
    const { data } = await apiV2.get('/objects', {
        params,
    });
    return data;
};
export const addObjectTag = async (data) => {
    return apiV2.post('/object-tags', data);
};
export const deleteObjectTag = async (tagId, objectId) => {
    return apiV2.delete(`/object-tags/${tagId}/object/${objectId}`);
};
export const getSingleObject = async (objectId, params) => {
    const { data } = await apiV2.get(`objects/${objectId}`, {
        params,
    });
    return data;
};
